import React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import styles from '../../styles/wizards/LinkExistingFilesWizard.scss';
import { __, bytesToSize, dateTimeFrom } from '../../core/utils';
import Image from '../../components/Image';

const FilesList = ({
  files,
  loading,
  selectedFileIds,
  selectablePageFileIds,
  allPageSelected,
  isAlreadyLinked,
  onToggleFile,
  onTogglePageFiles,
}) => (
  <div className={styles.files}>
    <div className={styles.fileHeader}>
      <input
        type='checkbox'
        checked={allPageSelected}
        disabled={_.isEmpty(selectablePageFileIds)}
        onChange={onTogglePageFiles}
      />
      <span className={styles.nameColumn}>
        {__('files.table.file-name', {}, 'File name')}
      </span>
      <span>{__('files.table.version', {}, 'Version')}</span>
      <span>{__('files.table.size', {}, 'Size')}</span>
    </div>

    <div className={styles.fileRows}>
      {loading && (
        <div className={styles.empty}>
          {__('general.loading', {}, 'Loading...')}
        </div>
      )}
      {!loading && _.isEmpty(files) && (
        <div className={styles.empty}>
          {__('files.wizard.no-files-found', {}, 'No files found.')}
        </div>
      )}
      {!loading &&
        _.map(files, (file) => {
          const alreadyLinked = isAlreadyLinked(file.id);
          const selected = _.includes(selectedFileIds, Number(file.id));

          return (
            <div
              key={file.id}
              className={classNames(
                styles.fileRow,
                file.archived && styles.archived,
                alreadyLinked && styles.alreadyLinked,
              )}
            >
              <input
                type='checkbox'
                checked={alreadyLinked || selected}
                disabled={alreadyLinked}
                onChange={() => onToggleFile(file.id)}
              />
              <div className={styles.fileName}>
                {file.thumbnail_url ? (
                  <Image
                    className={styles.thumbnail}
                    src={file.thumbnail_url}
                  />
                ) : (
                  <span className={styles.fileType}>
                    {_.toUpper(file.extension)}
                  </span>
                )}
                <span className={styles.fileDetails}>
                  <strong>{file.file_name}</strong>
                  <small>
                    {alreadyLinked
                      ? __('files.wizard.already-linked', {}, 'Already linked')
                      : dateTimeFrom(file.uploaded_at)}
                  </small>
                </span>
              </div>
              <span>{'V' + file.version}</span>
              <span>{file.size ? bytesToSize(file.size) : '—'}</span>
            </div>
          );
        })}
    </div>
  </div>
);

export default FilesList;
